module.exports = __webpack_public_path__ + "img/freshworks.79dc4a8f.svg";